module.exports = "/images/google-play-logo.svg?39b94d66e76861efd68ab29a914bf213";